import "./App.css";
import { Route, Routes } from "react-router-dom";
import Login from "./components/auth/Login";
import axios from "axios";
import { Unauthorized } from "./components/helper/HelperTwo";
import { ProtectedRoute } from "./components/helper/HelperOne";
import Customer from "./components/admin/customer/Customer";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ForgetPassword from "./components/auth/ForgetPassword";
import ResetPassword from "./components/auth/ResetPassword";
import Maintenance from "./components/admin/Maintenance";
import Lead from "./components/admin/LeadManagement/Lead";
import LeadDashboard from "./components/admin/LeadDashboard/LeadDashboard";
import TypeOfWork from "./components/admin/Masters/TypeOfWork/TypeOfWork";
import AdvertisementMode from "./components/admin/Masters/AdvertisementMode/AdvertisementMode";
import City from "./components/admin/Masters/City/City";
import Workers from "./components/admin/Workers/Workers";
import Salesmen from "./components/admin/Salesmen/Salesmen";
import LossReason from "./components/admin/Masters/LossReason/LossReason";
import Quotation from "./components/admin/Quotation/Quotation";
import QuotationReport from "./components/admin/Report/QuotationReport/QuotationReport";
import LeadReport from "./components/admin/Report/LeadReport/LeadReport";
import ProjectManager from "./components/admin/ProjectManager/ProjectManager";
import QuotationLossReason from "./components/admin/Masters/QuotationLossReason/QuotationLossReason";
import Priority from "./components/admin/Masters/Priority/Priority";
import SalesOrder from "./components/admin/SalesOrder/SalesOrder";
import SalesOrderStatus from "./components/admin/Masters/SalesOrderStatus/SalesOrderStatus";
import Sales from "./components/admin/Sales/Sales";
import LeadChat from "./components/admin/Report/LeadChat/LeadChat";
import MissingQuotationLead from "./components/admin/Report/MissingQuotationLead/MissingQuotationLead";
import DeliveryNote from "./components/admin/DeliveryNote/DeliveryNote";
import PaymentReceivable from "./components/admin/PaymentReceivable/PaymentReceivable";
import QuotationChat from "./components/admin/Report/QuotationChat/QuotationChat";

// axios.defaults.baseURL = 'https://leads.dreamsdigitall.in/api/1';
// axios.defaults.baseURL = 'https://leadsv1.dreamsdigitall.in/api/1';
axios.defaults.baseURL = "https://demo3.axnplus.in/api/1";
// axios.defaults.baseURL = "https://lead.axninfotech.in/api/1";
// axios.defaults.baseURL = "http://localhost/pradeep/edamarileads/ledamarileads/";
// axios.defaults.baseURL = "http://localhost/arun/edamariLead/ledamarileads/";
// axios.defaults.baseURL = 'http://localhost/murugesh/Edamaari/ledamarileads/';

function App() {
  // const user = JSON.parse(localStorage.getItem('user'));
  // const customerPermission = user?.customer_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const employeePermission = user?.employee_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const leadPermission = user?.lead_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const taskPermission = user?.task_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );
  // const quotationPermission = user?.quotation_role_based_access?.some(
  //   (access) => access.label_id == 1 && access.label_value != 0
  // );

  return (
    <div>
      <Routes>
        <Route path="/crm/" element={<Login />} />
        <Route path="/maintenance" element={<Maintenance />} />
        <Route path="/crm/forgot/password" element={<ForgetPassword />} />
        <Route path="/crm/reset/password/:id" element={<ResetPassword />} />
        <Route path="/crm/unauthorized" element={<Unauthorized />} />
        <Route
          path="/crm/customer"
          element={<ProtectedRoute element={<Customer />} allowed={true} />}
        />
        <Route
          path="/crm/lead"
          element={<ProtectedRoute element={<Lead />} allowed={true} />}
        />
        <Route
          path="/crm/workers"
          element={<ProtectedRoute element={<Workers />} allowed={true} />}
        />
        <Route
          path="/crm/salesmen"
          element={<ProtectedRoute element={<Salesmen />} allowed={true} />}
        />
        <Route path="/crm/lead_dashboard" element={<LeadDashboard />} />
        <Route
          path="/crm/type-of-work"
          element={<ProtectedRoute element={<TypeOfWork />} allowed={true} />}
        />
        <Route
          path="/crm/advertisement-mode"
          element={
            <ProtectedRoute element={<AdvertisementMode />} allowed={true} />
          }
        />
        <Route
          path="/crm/cities"
          element={<ProtectedRoute element={<City />} allowed={true} />}
        />
        <Route
          path="/crm/loss-reasons"
          element={<ProtectedRoute element={<LossReason />} allowed={true} />}
        />
        <Route
          path="/crm/quotation"
          element={<ProtectedRoute element={<Quotation />} allowed={true} />}
        />
        <Route
          path="/crm/sale/order"
          element={<ProtectedRoute element={<SalesOrder />} allowed={true} />}
        />
        <Route
          path="/crm/sales"
          element={<ProtectedRoute element={<Sales />} allowed={true} />}
        />
        <Route
          path="/crm/delivery/note"
          element={<ProtectedRoute element={<DeliveryNote />} allowed={true} />}
        />
        <Route
          path="/crm/payment/receivable"
          element={
            <ProtectedRoute element={<PaymentReceivable />} allowed={true} />
          }
        />
        <Route
          path="/crm/quotation/loss-reasons"
          element={
            <ProtectedRoute element={<QuotationLossReason />} allowed={true} />
          }
        />
        <Route
          path="/crm/lead_report"
          element={<ProtectedRoute element={<LeadReport />} allowed={true} />}
        />

        <Route
          path="/crm/quotation_report"
          element={
            <ProtectedRoute element={<QuotationReport />} allowed={true} />
          }
        />

        <Route
          path="/crm/project/manager"
          element={
            <ProtectedRoute element={<ProjectManager />} allowed={true} />
          }
        />

        <Route
          path="/crm/Priority"
          element={<ProtectedRoute element={<Priority />} allowed={true} />}
        />
        <Route
          path="/crm/sales/order/status"
          element={
            <ProtectedRoute element={<SalesOrderStatus />} allowed={true} />
          }
        />
        <Route
          path="/crm/lead/chat"
          element={<ProtectedRoute element={<LeadChat />} allowed={true} />}
        />
        <Route
          path="/crm/quotation/chat"
          element={
            <ProtectedRoute element={<QuotationChat />} allowed={true} />
          }
        />

        <Route
          path="/crm/missing/quotation/lead/"
          element={
            <ProtectedRoute element={<MissingQuotationLead />} allowed={true} />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
